import React from 'react';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { changeActiveInput } from 'modules/kiosk/containers/Kiosk/services/actions';
import GroupBtnLight from 'modules/shared/Forms/GroupBtnLight';
import { VerifyPhoneState } from './reducer';
import { clearStateVerify, isSucessVerify, verifyPhoneRequest } from './actions';
import VerifyModal from '../VerifyModal';
import { VerifyCodeSelector } from './selectors';

type Props = {
  value: string;
  inputVerifyField: string;
  mode: 'kiosk' | 'main';
  disabled?: boolean;
};

const VerifyPhone: React.FC<Props> = ({ value, inputVerifyField, mode, disabled = false }) => {
  const dispatch = useDispatch();
  const formik = useFormikContext();

  const { code, number, errorMsg, loading, isLoadingFields, isSuccess, isError }: VerifyPhoneState =
    useSelector(VerifyCodeSelector);

  const onCloseVerifyModal = () => {
    formik.setFieldValue(inputVerifyField, false);
    formik.setFieldValue('keybVerifyCode', '');

    dispatch(changeActiveInput(''));
    dispatch(clearStateVerify());
  };

  const onClickVerify = () => {
    formik.setFieldValue('keybVerifyCode', '');
    dispatch(changeActiveInput(''));

    if (value) return dispatch(verifyPhoneRequest(value, inputVerifyField));

    dispatch(verifyPhoneRequest(number, inputVerifyField));
  };

  const successVerifyModal = () => {
    dispatch(isSucessVerify(true));

    formik.setFieldValue(isLoadingFields, true);
    formik.setFieldValue('keybVerifyCode', '');
    dispatch(changeActiveInput(''));

    setTimeout(() => {
      dispatch(clearStateVerify());
    }, 1500);
  };

  return (
    <>
      <GroupBtnLight
        loading={loading}
        // eslint-disable-next-line
        errorMsg={errorMsg ? errorMsg : ''}
        isField={inputVerifyField}
        isLoadingField={isLoadingFields}
        onClick={onClickVerify}
        disabled={disabled}
        btnIcon="phoneForward"
        mode={mode}
      />
      <VerifyModal
        show={!!number}
        code={code}
        successVerify={isSuccess}
        mode={mode}
        errorVerify={isError}
        errorMsg={errorMsg}
        onHide={onCloseVerifyModal}
        onClickVerify={onClickVerify}
        successVerifyModal={successVerifyModal}
      />
    </>
  );
};

export default VerifyPhone;
